import React, { useContext, useEffect, useRef, useState } from "react";
import "../../css_files/Quotation/QuotationTable.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import getCookie from "../../api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import Pagination from "../Homepage/Pagination";
import { triggerscroll } from "../Homepage/Homepage";
import moment from "moment";

function QuotationTable({
  quotationData,
  setQuotationId,
  setTicketId,
  setEnquiryId,
  refresh,
  setrefresh,
  loading,
  readPermission,
  updatePermission,
  deletePermission,
}) {
  const nav = useNavigate();

  const tableRef = useRef();
  const [deleteLoader, setDeleteLoader] = useState([]);

  useEffect(() => {
    setDeleteLoader(Array.from({ length: quotationData?.length }, () => false));
  }, [quotationData?.length]);

  return (
    <>
      <blockquote
        className="navigate-left-right-bottom-table"
        style={{ marginBottom: "3px" }}
      >
        <button
          onClick={() => {
            tableRef.current.scrollBy({
              left: -tableRef.current.scrollWidth,
              behavior: "smooth",
            });
          }}
        >
          <i className="fa-solid fa-arrow-left"></i>
        </button>

        <button
          onClick={() => {
            tableRef.current.scrollBy({
              left: tableRef.current.scrollWidth,
              behavior: "smooth",
            });
          }}
        >
          <i className="fa-solid fa-arrow-right"></i>
        </button>
      </blockquote>

      <section className="table" ref={tableRef}>
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(14, 1fr)" }}>
              <blockquote style={{ width: "10rem" }}>Series Id</blockquote>
              <blockquote style={{ width: "10rem" }}>
                Company / Organization Name
              </blockquote>
              <blockquote style={{ width: "10rem" }}>Sub Total</blockquote>
              <blockquote style={{ width: "10rem" }}>Final Total</blockquote>
              <blockquote style={{ width: "10rem" }}>GST Amount</blockquote>
              <blockquote style={{ width: "10rem" }}>GST Percentage</blockquote>
              <blockquote style={{ width: "10rem" }}>
                Discount Amount
              </blockquote>
              <blockquote style={{ width: "10rem" }}>
                Discount Percentage
              </blockquote>
              <blockquote style={{ width: "10rem" }}>Grand Total</blockquote>
              <blockquote style={{ width: "10rem" }}>Created On</blockquote>
              <blockquote style={{ width: "10rem" }}>Last Updated</blockquote>
              <blockquote
                style={{ width: "12rem", gridColumn: "span 3" }}
                colSpan={3}
              >
                Actions
              </blockquote>
            </aside>
          </div>
          {quotationData && (
            <div>
              {readPermission() ? (
                loading ? (
                  <aside style={{ gridTemplateColumns: "repeat(14, 1fr)" }}>
                    <blockquote style={{ gridColumn: "span 14" }}>
                      <center>
                        <i
                          class="fa-solid fa-snowflake fa-spin"
                          style={{ fontSize: "2.5rem" }}
                        ></i>
                      </center>
                    </blockquote>
                  </aside>
                ) : quotationData.length > 0 ? (
                  quotationData.map((quotation, i) => (
                    <aside style={{ gridTemplateColumns: "repeat(14, 1fr)" }}>
                      <blockquote style={{ width: "10rem" }}>
                        {quotation.seriesId}
                      </blockquote>

                      <blockquote style={{ width: "10rem" }}>
                        {quotation.customer.orgName}
                      </blockquote>
                      <blockquote style={{ width: "10rem" }}>
                        {quotation.symbol} {quotation.subTotal}
                      </blockquote>
                      <blockquote style={{ width: "10rem" }}>
                        {quotation.symbol} {quotation.finalTotal}
                      </blockquote>
                      <blockquote style={{ width: "10rem" }}>
                        {quotation.symbol} {quotation.gstAmount}
                      </blockquote>
                      <blockquote style={{ width: "10rem" }}>
                        {quotation.gstPercentage}%
                      </blockquote>
                      <blockquote style={{ width: "10rem" }}>
                        {quotation.symbol} {quotation.discountValue}
                      </blockquote>
                      <blockquote style={{ width: "10rem" }}>
                        {quotation.discountPercentage}%
                      </blockquote>
                      <blockquote style={{ width: "10rem" }}>
                        {quotation.symbol} {quotation.grandTotal}
                      </blockquote>
                      <blockquote style={{ width: "10rem" }}>
                        {moment(new Date(quotation.createdDate)).format(
                          "DD/MM/YYYY"
                        )}
                      </blockquote>
                      <blockquote style={{ width: "10rem" }}>
                        {quotation.updatedDate
                          ? moment(new Date(quotation.updatedDate)).format(
                              "DD/MM/YYYY"
                            )
                          : "---"}
                      </blockquote>
                      <blockquote
                        onClick={() => {
                          axiosInstance
                            .get(
                              `${
                                process.env.REACT_APP_API_URL
                              }/api/v1/Ticket/${encodeURIComponent(
                                quotation.ticketId
                              )}`
                            )
                            .then((res) => {
                              setEnquiryId(res.data.enquirySeriesId);
                              setTicketId(quotation.ticketId);
                              setQuotationId(quotation.seriesId);
                              nav("/dashboard/checkin/steps/step3");
                            })
                            .catch(console.log);
                        }}
                        style={{ width: "4rem" }}
                      >
                        <i className="fa-solid fa-eye"></i>
                      </blockquote>
                      <blockquote
                        onClick={() =>
                          nav(
                            `/dashboard/quotations/edit/${quotation.seriesId}`
                          )
                        }
                        style={{
                          pointerEvents: updatePermission() && "none",
                          width: "4rem",
                        }}
                      >
                        <i
                          className="fa-solid fa-pen-to-square"
                          style={{
                            color: updatePermission() && "gray",
                          }}
                        ></i>
                      </blockquote>
                      <blockquote
                        style={{
                          pointerEvents: deletePermission() && "none",
                          width: "4rem",
                        }}
                        onClick={() => {
                          Swal.fire({
                            icon: "error",
                            showCancelButton: true,
                            title: "Are you sure?",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setDeleteLoader((prev) =>
                                prev.map((_, j) => j === i)
                              );
                              axiosInstance
                                .put(
                                  `${process.env.REACT_APP_API_URL}/api/v1/Quotation`,
                                  {
                                    SeriesId: quotation.seriesId,
                                    isDeleted: true,
                                  }
                                )
                                .then((res) => {
                                  toast.success("Record Deleted Successfully", {
                                    position: "bottom-center",
                                    theme: "dark",
                                  });
                                  setrefresh(!refresh);
                                })
                                .catch(console.log)
                                .finally(() => {
                                  setDeleteLoader((prev) =>
                                    prev.map((_) => false)
                                  );
                                });
                            }
                          });
                        }}
                      >
                        {deleteLoader[i] ? (
                          <i
                            class="fa-solid fa-hurricane fa-spin"
                            title="Please Wait..."
                          ></i>
                        ) : (
                          <i
                            className="fa-solid fa-trash"
                            style={{
                              color: deletePermission() && "gray",
                            }}
                          ></i>
                        )}
                      </blockquote>
                    </aside>
                  ))
                ) : (
                  <aside style={{ gridTemplateColumns: "repeat(14, 1fr)" }}>
                    <blockquote style={{ gridColumn: "span 14" }}>
                      <center>
                        <h3>No Quotations Created</h3>
                      </center>
                    </blockquote>
                  </aside>
                )
              ) : (
                <aside style={{ gridTemplateColumns: "repeat(14, 1fr)" }}>
                  <blockquote style={{ gridColumn: "span 14" }}>
                    <center>
                      <p>You Do Not Have Read Permission</p>
                    </center>
                  </blockquote>
                </aside>
              )}
            </div>
          )}
        </section>
      </section>
    </>
  );
}

export default QuotationTable;
